module.exports = "/assets/images/c2b6456b0a38c7b772ab83af587c4e12.png";